import React from 'react'
import {Col, Row, Nav, NavItem, NavLink, TabContent, TabPane} from 'reactstrap'
import Loader from 'react-loader-spinner'
import JohnDeereButton from './JDIntegrationButton'
import AddOnIcon from 'react-icons/lib/fa/plug'
import DisabledIcon from 'react-icons/lib/fa/times-circle'
import EnabledIcon from 'react-icons/lib/fa/check'

import "../../stylesheets/JDIntegrationPanel.css"



let JDIntegrationPanel = ({integrated=false, loading=false, integrateButton=true, onIntegrateWithJDClick, onRemoveIntegrationClick}) =>
    <Row className="col-12 justify-content-center integrations-panel">
        {loading ?
            <div className="p-5 mt-4 w-100 h-100">
                <Loader type="TailSpin" color="orange" width={60} height={60}/>
            </div>:
                (integrated ?
                    <div className="justify-content-end m-4 text-right col-12 col-sm-10 col-md-8 col-lg-6">
                        <div className="rounded border-light-sf-blue integration-pill mb-2 col-12 p-0">
                            <div className="bg-success text-white m-0 p-2 pr-3 d-inline-block text-center col-10 col-md-8">
                                <AddOnIcon className="mr-2"/>
                                <span className="d-inline d-lg-none">
                                    John&nbsp;Deere Ops&nbsp;Center
                                </span>
                                <span className="d-none d-lg-inline">
                                    John&nbsp;Deere Operations&nbsp;Center
                                </span>
                            </div>
                            <div className="bg-muted-sf-blue sf-blue border-left m-0 p-2 text-center font-weight-bold d-inline-block col-2 col-md-4">
                                <EnabledIcon className="mr-2"/>
                                <span className="d-none d-md-inline">
                                    Enabled
                                </span>
                            </div>
                        </div>
                        <a href="/account?tab=2" className="mr-3">Notifications</a>
                        <a href="javascript:void(0)" className="text-danger" onClick={onRemoveIntegrationClick}>Disable</a>
                    </div>:
                        <div className="justify-content-end m-4 text-right col-12 col-sm-10 col-md-8 col-lg-6">
                            <div className="rounded border-light-sf-blue integration-pill mb-2 col-12 p-0">
                                <div className="bg-light-sf-blue text-white m-0 p-2 text-center d-inline-block col-10 col-md-8">
                                    <AddOnIcon className="mr-2"/>
                                    <span className="d-inline d-lg-none">
                                        John&nbsp;Deere Ops&nbsp;Center
                                    </span>
                                    <span className="d-none d-lg-inline">
                                        John&nbsp;Deere Operations&nbsp;Center
                                    </span>
                                </div>
                                <div className="bg-muted-sf-blue sf-blue border-left m-0 p-2 text-center font-weight-bold d-inline-block col-2 col-md-4">
                                    <DisabledIcon className="mr-2"/>
                                    <span className="d-none d-md-inline">
                                        Not&nbsp;Enabled
                                    </span>
                                </div>
                                
                            </div>
                            
                            <div className='d-flex justify-content-center p-4'>
                            {integrateButton ?
                            <JohnDeereButton onClick={onIntegrateWithJDClick} /> : null
                            }
                            </div>
                        </div>

                )}
    </Row>

export default JDIntegrationPanel


// WEBPACK FOOTER //
// ./src/components/ui/JDIntegrationsPanel.js